<template>
    <div>
        <dx-grid
            url="purimTrackingDetails"
            :baseUrl="getDomain()"
            :columns="columns"
            :title="title"
            ref="grid"
            navigationPath="PurimStudentView"
            navigationField="studentid"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Tracking Details",
        columns: [
            {
                label: "Student ID",
                field: "studentid",
                visible: true,
                link: "PurimStudentView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Name",
                field: "fullName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "NameE",
                field: "fullNameE",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Father",
                field: "father",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Description",
                field: "description",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Details",
                field: "data",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Entrered By",
                field: "entreredBY",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Amount",
                field: "amount",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Updated By",
                field: "updatedBY",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Updated On",
                field: "updatedOn",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Column Name",
                field: "columnName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Code",
                field: "code",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "First Name",
                field: "fname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Last Name",
                field: "laname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Grade",
                field: "grade",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Teacher",
                field: "teacher",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            }
        ]
    }),
    async created() {
        const trackSetup = await this.getTrackSetups();

        this.columns.forEach(column => {
            if (
                ![
                    "track1",
                    "track2",
                    "track3",
                    "track4",
                    "track5",
                    "track6",
                    "track7",
                    "track8",
                    "track9"
                ].includes(column.field)
            )
                return;

            const code = column.field.substr(-1);

            const setup = trackSetup.find(g => g.code == code);

            column.label = setup.description;
        });
    },
    methods: {
        async getTrackSetups() {
            const trackSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getTrackSetup"
            );

            return trackSetups;
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44338"
                : "https://purim-admin-portal.azurewebsites.net";
        }
    }
};
</script>
